module.exports = __webpack_public_path__ + "img/ellaklara.04d3af68.jpeg";